/* global wc */
import $ from 'jquery';
import core from '../core';

class BlocksCheckout {
    /**
     * Setup
     */
    constructor() {
        // this.registerCheckoutFilters();
        this.initTranslations();
    }

    /**
     * Events
     */
    bindEvents() {
        // CookieBar.$el.on('click', '.js-cookie-bar__accept-btn', CookieBar.onAccept);
    }

    /**
     * Events
     */
    registerCheckoutFilters() {
        const { registerCheckoutFilters } = window.wc.blocksCheckout;

        const modifyTotalLabel = ( defaultValue, extensions, args ) => {
            return 'Deposit due today';
        };

        // registerCheckoutFilters( 'example-extension', {
        //     totalLabel: modifyTotalLabel,
        // } );

        // console.log(registerCheckoutFilters, 'test');
    }

    /**
     * Events
     */
    initTranslations() {
        setTimeout(() => {
            const $cartOrderSummaryShippingBlock = $('.wp-block-woocommerce-cart-order-summary-shipping-block');
            $cartOrderSummaryShippingBlock.find('.wc-block-components-totals-item__label').text('Alege metoda de livrare');
        }, 250);
    }
}

core.Ready(() => {
    new BlocksCheckout();
});
